// extracted by mini-css-extract-plugin
module.exports = {"breakSmall":"767px","breakMedium":"1280px","container":"ContactUsPage_container__2lLBR","content":"ContactUsPage_content__1rvJt"};